import { render } from "./TableWithFixedColumn.vue?vue&type=template&id=7969768a"
import script from "./TableWithFixedColumn.vue?vue&type=script&lang=ts"
export * from "./TableWithFixedColumn.vue?vue&type=script&lang=ts"
script.render = render

export default script